import { darken } from '@mui/material/styles';
import makeStyles from '@ui/utils/makeStyles';

type StyleProps = {
  objectPosition?: string;
}

export default makeStyles<StyleProps>()((theme, { objectPosition }) => ({
  makerHero: {
    maxHeight: 220,
    minHeight: 0,
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    overflow: 'visible',
    marginBottom: 150,
    backgroundSize: 'cover',
    backgroundPosition: objectPosition,
    paddingLeft: 0,
    paddingRight: 0,
  },

  filterList: {
    width: '100%',
  },
  avatar: {
    position: 'relative', 
    top: 130,
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.up('lg')]: {
      marginLeft: 50
    },
  },
  locationWrapper: { 
    position: 'relative',
    top: 150,
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      position: 'relative',
      top: 100,
      width: '76%',
      marginLeft: 'auto',
    },
  },
  tab: {
    textTransform: 'none',
    maxWidth: 'none',
    paddingLeft: 20,
    paddingRight: 20,
    color: '#cecece',
    '&.Mui-selected': {
      color: theme.palette.common.black
    },
    '&:first-of-type': {
      paddingLeft: 0,
    }
  },
  topIcon: {
    fill: '#b6bdc7',
    height: 20,
    width: 'auto',
    marginRight: theme.spacing(2),
  },
  likeButton: {
    backgroundColor: '#f6f6f7',
    '&:hover': {
      backgroundColor: darken('#f6f6f7', .05),
    }
  },
  sortButtonSmall: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(0.5, 1),
    border: '1px solid #DDDDDD',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  sortButtonLarge: {
    position: 'absolute',
    right: 0,
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(0.5, 1),
    border: '1px solid #DDDDDD',
    display: 'flex',
    justifyContent: 'space-between',
  }
}));
